// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return _default;
    }
});
var _react = /*#__PURE__*/ _interop_require_wildcard(require("react"));
var _IeOutlined = /*#__PURE__*/ _interop_require_default(require("@ant-design/icons-svg/lib/asn/IeOutlined"));
var _AntdIcon = /*#__PURE__*/ _interop_require_default(require("../components/AntdIcon"));
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function _getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return (_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function _interop_require_wildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) {
        return obj;
    }
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") {
        return {
            default: obj
        };
    }
    var cache = _getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) {
        return cache.get(obj);
    }
    var newObj = {
        __proto__: null
    };
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj){
        if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
            var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
            if (desc && (desc.get || desc.set)) {
                Object.defineProperty(newObj, key, desc);
            } else {
                newObj[key] = obj[key];
            }
        }
    }
    newObj.default = obj;
    if (cache) {
        cache.set(obj, newObj);
    }
    return newObj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
var IeOutlined = function(props, ref) {
    return /*#__PURE__*/ _react.createElement(_AntdIcon.default, _object_spread_props(_object_spread({}, props), {
        ref: ref,
        icon: _IeOutlined.default
    }));
};
/**![ie](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTg1Mi42IDM2Ny42YzE2LjMtMzYuOSAzMi4xLTkwLjcgMzIuMS0xMzEuOCAwLTEwOS4xLTExOS41LTE0Ny42LTMxNC41LTU3LjktMTYxLjQtMTAuOC0zMTYuOCAxMTAuNS0zNTUuNiAyNzkuNyA0Ni4zLTUyLjMgMTE3LjQtMTIzLjQgMTgzLTE1MS43QzMxNi4xIDM3OC4zIDI0Ni43IDQ3MCAxOTQgNTY1LjZjLTMxLjEgNTYuOS02NiAxNDguOC02NiAyMTcuNSAwIDE0Ny45IDEzOS4zIDEyOS44IDI3MC40IDYzIDQ3LjEgMjMuMSA5OS44IDIzLjQgMTUyLjUgMjMuNCAxNDUuNyAwIDI3Ni40LTgxLjQgMzI1LjItMjE5SDY5NC45Yy03OC44IDEzMi45LTI5NS4yIDc5LjUtMjk1LjItNzEuMmg0OTMuMmM5LjYtNjUuNC0yLjUtMTQzLjYtNDAuMy0yMTEuN3pNMjI0LjggNjQ4LjNjMjYuNiA3Ni43IDgwLjYgMTQzLjggMTUwLjQgMTg1LTEzMy4xIDczLjQtMjU5LjkgNDMuNi0xNTAuNC0xODV6bTE3NC0xNjMuM2MzLTgyLjcgNzUuNC0xNDIuMyAxNTYtMTQyLjMgODAuMSAwIDE1MyA1OS42IDE1NiAxNDIuM2gtMzEyem0yNzYuOC0yODEuNGMzMi4xLTE1LjQgNzIuOC0zMyAxMDguOC0zMyA0Ny4xIDAgODEuNCAzMi42IDgxLjQgODAuNiAwIDMwLTExLjEgNzMuNS0yMS45IDEwMS44LTM5LjMtNjMuNS05OC45LTEyMi40LTE2OC4zLTE0OS40eiIgLz48L3N2Zz4=) */ var RefIcon = /*#__PURE__*/ _react.forwardRef(IeOutlined);
if (process.env.NODE_ENV !== 'production') {
    RefIcon.displayName = 'IeOutlined';
}
var _default = RefIcon;
